interface EventInfoItemProps {
    label: string
    value: string
}

export const EventInfoItem = ({ label, value }: EventInfoItemProps) => {
    return (
        <>
            <div className="flex gap-3 w-full items-center">
                <p className="text-base leading-[24.8px] font-black text-[#242F3E] opacity-70 whitespace-nowrap">{label}</p>
                <div className="border-b-[1px] border-[#CCCCCC] w-full"></div>
            </div>
            <p className="text-[19.2px] leading-[29.76px] font-bold text-[#333]">{value}</p>
        </>
    )
}

